import { useState } from 'react';
import PropTypes from 'prop-types';

import { REFINEMENT_PROMPT_MAX_LENGTH } from 'utlis/constants';

const RefinementInput = ({ onSubmit, isSubmitting, disabled }) => {
  const [promptText, setPromptText] = useState('');

  const isOverLimit = promptText.length > REFINEMENT_PROMPT_MAX_LENGTH;
  const canSubmit = !isOverLimit && !isSubmitting && !disabled;

  const handleSubmit = () => {
    if (!canSubmit) {
      return;
    }

    onSubmit(promptText.trim());
    setPromptText('');
  };

  const handleKeyDown = e => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit();
    }
  };

  return (
    <div className="flex flex-col">
      <div
        className="flex items-center justify-between gap-[16px] rounded-lg border border-[#E1E4E8]
          bg-[#F8F9FB] p-[4px] pl-[16px]"
      >
        <input
          type="text"
          className="flex-[4] bg-transparent text-[14px] font-normal leading-5 text-[#606776]
            placeholder:text-[14px] placeholder:font-normal placeholder:leading-5 placeholder:text-[#606776]
            focus:outline-none disabled:cursor-not-allowed disabled:opacity-50"
          placeholder="Change this..."
          value={promptText}
          onChange={e => setPromptText(e.target.value)}
          onKeyDown={handleKeyDown}
          maxLength={REFINEMENT_PROMPT_MAX_LENGTH + 1}
          disabled={isSubmitting || disabled}
        />
        <button
          type="button"
          className="flex items-center justify-center whitespace-nowrap rounded-lg bg-[#1B988E] px-3 py-2
            text-xs font-medium leading-4 text-white transition-colors hover:bg-[#17867d]
            disabled:cursor-not-allowed disabled:opacity-50"
          onClick={handleSubmit}
          disabled={!canSubmit}
        >
          {isSubmitting ? 'Generating…' : 'Generate variant'}
        </button>
      </div>
    </div>
  );
};

RefinementInput.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool,
  disabled: PropTypes.bool,
};

RefinementInput.defaultProps = {
  isSubmitting: false,
  disabled: false,
};

export default RefinementInput;
